import Layout from '../../components/layout'
import { NoOrders } from './style'

const Index = () => {
  return (
    <Layout>
        <NoOrders>
          <span className='icon'>
            <i className="fas fa-ban"></i>
          </span>
          <div>
          <p>You do not have access to this page</p>
          <p>Please contact your administrator</p>
          </div>
        </NoOrders>
    </Layout>
  )
}

export default Index